import { render } from "./OrgEditTrainee.vue?vue&type=template&id=028dc804&scoped=true"
import script from "./OrgEditTrainee.vue?vue&type=script&lang=js"
export * from "./OrgEditTrainee.vue?vue&type=script&lang=js"

import "./OrgEditTrainee.vue?vue&type=style&index=0&id=028dc804&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028dc804"]])

export default __exports__